import { findNodeById } from '@sonifi/wb-tree/utils/helper';
import uniqueId from 'lodash/uniqueId';

const checkNodeForDeletedMedia = ({ node, mediaDependencies }) => {
  const hasDeletedContent = node.subject?.image?.find(
    (img) => !mediaDependencies.find((imgDep) => imgDep.uri === img.image),
  );
  return !!hasDeletedContent;
};

const getChildrenMapped = ({ children, embedded, mediaDependencies }) => {
  children.forEach((ch, index) => {
    if (ch.children && Array.isArray(ch.children) && ch.children.length) {
      getChildrenMapped({
        children: children[index].children,
        embedded,
        mediaDependencies,
      });
    }
    const auxCh = {
      ...ch,
      subject: embedded[ch.subject],
      indicatorImage: {
        showIcon: embedded[ch.subject]?.options?.length > 0,
        showTooltip: false,
      },
      secondaryValue: '', // Always empty for Guest Request
    };
    children[index] = {
      ...auxCh,
      id: ch?.id || uniqueId(`${Date.now()}_`),
      subject: {
        ...auxCh.subject,
        isZombie: false,
        hasDeletedContent: checkNodeForDeletedMedia({
          node: auxCh,
          mediaDependencies,
        }),
      },
    };
  });
  return children;
};

export const getServiceMenuMapped = ({ data, group, mediaDependencies }) => {
  const children = getChildrenMapped({
    children: data.objects[0].menu.children,
    embedded: data._embedded,
    mediaDependencies,
  });

  const menu = {
    ...data.objects[0].menu,
    id: data.objects[0].menu?.id || uniqueId(`${Date.now()}_`),
    group,
    children,
    subject: data._embedded[data.objects[0].menu.subject],
    indicatorImage:
      data._embedded[data.objects[0].menu.subject]?.options?.length > 0,
    secondaryValue: '',
  };

  const serviceMenu = {
    ...data.objects[0],
    menu,
  };

  return serviceMenu;
};

export const getInicialNode = ({ id, menu }) => {
  // node Id cuold be String or Int
  const nodeId = id ? (String(id).includes('_') ? id : parseInt(id)) : null;
  const node = findNodeById({ menu, nodeId }) || menu;
  return node;
};
